import React from 'react';
import ShippableRibbon from './ShippableRibbon';
import PriceTag from './PriceTag/PriceTag';
import formatRelativeDate from './formatRelativeDate';
import AdCard from './AdCard';
import AdLink from './AdLink';
import AdImage from './AdImage';
import useClickableBlock from './useClickableBlock';
import { BapAd } from './adType';
import { useActiveAds } from '../ActiveAdsContext';

const c = {
    image: 'rounded-8 md:rounded-b-0',
    heading: 'mb-0 mt-8 text-16 font-normal sf-line-clamp-3',
    heart: 'sf-ad-interactive',
};

const IMAGE_SIZES =
    '(min-width: 1300px) 225px, (min-width: 990px) 235px, (min-width: 768px) 33vw, 50vw';

type BapAdProps = {
    ad: BapAd;
    onClick?: (event: React.MouseEvent) => void;
};

function Ad(props: BapAdProps) {
    const { ad, onClick } = props;
    const {
        ad_id,
        flags,
        heading,
        image,
        location,
        main_search_key,
        price,
        timestamp,
        trade_type,
    } = ad;

    const { urls } = useActiveAds();
    const adUrl = `${urls.ad}?finnkode=${ad_id}`;

    const [blockRef, linkRef, interactiveRef] = useClickableBlock();

    const isPrivate = flags?.includes('private');
    const isSold = ad.flags?.includes('sold');

    const [SaveAd, setSaveAd] = React.useState<any>();
    React.useEffect(() => {
        const temp = async () => {
            const importedSaveAd = (await import("./SaveAd")).SaveAd;
            setSaveAd(importedSaveAd);
        }
        temp()

    }, []);

    return (
        <AdCard className="sf-bap-ad rounded-8 w-full h-full" flat ref={blockRef}>
            <div className="relative">
                <AdImage
                    alt=""
                    adaptive
                    crop
                    aspectClass="md:aspect-w-1 md:aspect-h-1"
                    imageClass={c.image}
                    sizes={IMAGE_SIZES}
                    {...image}
                />
                <span className="absolute bottom-8 left-8">
                    <PriceTag price={price} searchKey={main_search_key} tradeType={trade_type} />
                </span>
            </div>
            <div className="pt-8 pb-16 md:pt-12 md:px-16">
                <div className="flex justify-between">
                    <span className="text-12 text-gray-500">{location}</span>
                    <span className="text-12 text-gray-500">{formatRelativeDate(timestamp)}</span>
                </div>
                <h3 className={c.heading}>
                    <AdLink ref={linkRef} href={adUrl} onClick={onClick}>
                        {heading}
                    </AdLink>
                </h3>
                {isPrivate && (
                    <span className="mt-8 hidden md:inline-block px-8 py-4 rounded-16 text-12 bg-bluegray-100">
                        Privat
                    </span>
                )}
            </div>
            {!isSold && (
                <ShippableRibbon
                    ad={ad}
                    className="absolute top-0 left-0"
                    ribbonClass="border-none"
                />
            )}
            {SaveAd &&
                <span className={`absolute top-8 right-8 ${c.heart}`}>
                    <SaveAd ref={interactiveRef} variant="heart-on-image" itemId={ad_id} />
                </span>
            }
        </AdCard>
    );
}

export default Ad;
